/** @jsx jsx */

import { jsx, render, SelectionSet, Field, Variable, Mutation } from "graphql-jsx";
import { clients } from "utils/clients";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  uuid?: string;
}>;

export const DeleteMetadataCompany = async (option: Option) => {
  const $uuid = <Variable name="uuid" scalar={<UuidScalar isNullable={true} />} value={option.uuid} />;

  const { query, variables } = render(
    <Mutation operationName="DELETE_METADATA_COMPANY">
      <SelectionSet
        name="deleteMetadata_company_relation"
        alias="deleteMetadataCompany"
        argument={{
          where: {
            id: $uuid
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    deleteMetadataCompany: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.metadata.request<Data>(query, variables);
};
